import React from 'react'
import './footer.css'

const Footer = () =>{
    return(
        <footer className="footer">
            <div className="footer__container container">
                <h1 className="footer__title">Abdulhamid Shahade</h1>
                
                <ul className="footer__list">
                    <li>
                        <a href="#about" className="footer__link">About</a>
                    </li>
                    <li>
                        <a href="#project" className="footer__link">Berryfy</a>
                    </li>
                    <li>
                        <a href="#services" className="footer__link">Services</a>
                    </li>
                </ul>

                <span className="version">version 1.0</span>
            
            
                <div className="footer__social">
                    <a href="https://www.linkedin.com/in/abdulhamidshahade/" 
               className="footer__social-link" target="_blank" rel="noreferrer">
                <i className="bx bxl-linkedin" ></i>
            </a>
            <a href="https://github.com/abdulhamidshahade" 
               className="footer__social-link" target="_blank" rel="noreferrer">
                <i className="bx bxl-github" ></i>
            </a>
            <a href="https://www.youtube.com/@AbdulhamidShahade" 
               className="footer__social-link" target="_blank" rel="noreferrer">
               <i className="bx bxl-youtube" ></i>
            </a>
                </div>
                <span className="footer__copy">&#169; Abdulhamid Shahade. All rights reserved</span>
            </div>
        </footer>
    )
}

export default Footer;
